import styled from 'styled-components';
import { COLORS } from '@/theme';

/** Same footprint as product photo tiles (ProductPhotosField `StyledPhotoItem`). */
export const StyledBlogImagePreviewShell = styled.div`
  position: relative;
  width: 11.25rem;
  height: 11.25rem;
  max-width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid ${COLORS.DIVIDER};
  background: ${COLORS.BRIGHT_GRAY};

  .ant-image {
    width: 100%;
    height: 100%;
  }

  .ant-image-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
